import { nanoid } from "nanoid";
import { ButtonPrimaryV2, Container, PaddingTopBottom40, colors } from "oolib";
import React, { useState } from "react";
import { SidebarLayoutV2 } from "../../layout/SidebarLayoutV2";
import { useDynamicLayoutHeight } from "./utils/useDynamicLayoutHeight";
import { DataVizWidgetGenerator } from "./comps/DataVizWidgetGenerator";
import FilterModule from "../../discovery/FilterModule";
import { useGetQueryData } from "../../../utils/react-query-hooks/general";
import { useAutoGenFilterConfigsFromTpl } from "../utils/useAutoGenFilterConfigsFromTpl";

export const InsightMatrix = () => {
  const { parentWrapperRef, gridHeightCSS } = useDynamicLayoutHeight();

  const [vizData, setVizData] = useState([{ id: "1" }]);

  const [activeFilters, setActiveFilters] = useState([])

  const allTpls = useGetQueryData('allTpls')

  const getSelectedTpls = ({vizData, allTpls}) => {
    const contentTypes = vizData?.map(d => d.contentType).filter(Boolean);
    if(!contentTypes || contentTypes.length === 0) return [];
    //else
    return contentTypes.map(c => allTpls.find(tpl => tpl.kp_content_type === c)).filter(Boolean)
  }

  const filterConfig = useAutoGenFilterConfigsFromTpl({
          selectedTpls: getSelectedTpls({vizData, allTpls}),
          
          filterScopes:['doc']
        })

  return (
    <div ref={parentWrapperRef}>
      <SidebarLayoutV2
        gridHeightCSS={gridHeightCSS}
        lsbComp={
        <FilterModule
        filterConfig={filterConfig}
        activeFilters={activeFilters}
        setActiveFilters={setActiveFilters}
        usedIn={"insightMatrix"}
        />
      }
      >
        <Container style={{ height: '100%'}}>
          <PaddingTopBottom40>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "1rem",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem",
                }}
              >
                {vizData.map((d, i) => {
                  if (i % 2 === 0) {
                    return (
                      <DataVizWidgetGenerator
                        id={d.id}
                        vizData={vizData[i]}
                        setVizData={setVizData}
                        index={i}
                        activeFilters={activeFilters}
                      />
                    );
                  } else {
                    return null;
                  }
                })}
                {vizData.length % 2 === 0 ? (
                  <ButtonPrimaryV2
                    onClick={() =>
                      setVizData((prev) => [...prev, { id: nanoid(6) }])
                    }
                  >
                    Add another
                  </ButtonPrimaryV2>
                ) : null}
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem",
                }}
              >
                {vizData.map((d, i) => {
                  if (i % 2 === 1) {
                    return (
                      <DataVizWidgetGenerator
                        vizData={vizData[i]}
                        setVizData={setVizData}
                        id={d.id}
                        index={i}
                        activeFilters={activeFilters}
                      />
                    );
                  } else {
                    return null;
                  }
                })}
                {vizData.length % 2 === 1 ? (
                  <ButtonPrimaryV2
                    onClick={() =>
                      setVizData((prev) => [...prev, { id: nanoid(6) }])
                    }
                  >
                    Add another
                  </ButtonPrimaryV2>
                ) : null}
              </div>
            </div>
          </PaddingTopBottom40>
        </Container>
      </SidebarLayoutV2>
    </div>
  );
};
